import React, { Component } from "react";
import { Label, Table, InputGroup, InputGroupAddon } from "reactstrap";
import { connect } from "react-redux";
import { reduxForm, Field, formValueSelector } from "redux-form";
import moment from "moment";
import MapCenterPoint from "../utils/domainMapCenterPointAutoSuggest";

import { getHourMinutesAndSeconds } from "../../../helper";
import { Input } from "../../../core";
import {
  required,
  checkHourValue,
  checkMinValue,
  checkRestrictionMinValue,
  checkSecValue,
  validateRestrictionCampaignDuration
} from "../../../helper/validation";

import SelectAsync from "../../../core/form/selectAsyncClass";

class DomainDetail extends Component {
  // eslint-disable-next-line no-useless-constructor
  constructor(props) {
    super(props);
    this.state = {
      disableUpdateButton: true,
      defaultCampaignUpdateButton: true
    };
  }

  enableUpdateButton = flag => {
    this.setState({ disableUpdateButton: flag });
  };

  enableDefaultCampaignUpdateButton = flag => {
    this.setState({ defaultCampaignUpdateButton: flag });
  };

  render() {
    const { attributes } = this.props.domains[0];
    const time = getHourMinutesAndSeconds(attributes.screenshotTime);
    const { handleSubmit, domainDefaultCampaign } = this.props;

    return (
      <div className="row domainModal">
        <div className="col-md-7">
          <div className="networkInformation">
            <div className=" userProfile__info">
              <h4 className="userProfile__headerTitle">
                {" "}
                <i className="mr-3 bx bxs-pencil" />
                Edit Domain Info
              </h4>
              <form className="validate-form">
                <div className="userProfile__body nameField form-validation-arrange userinput">
                  <Field
                    label="Name"
                    component={Input}
                    name="name"
                    type="text"
                    validate={required}
                    placeholder="Name"
                    props={
                      (this.props.roles.includes("SuperAdmin") &&
                        attributes.name === "wicket") ||
                      !this.props.roles.includes("SuperAdmin")
                        ? { disabled: true }
                        : { disabled: false }
                    }
                    onChange={() => this.enableUpdateButton(false)}
                  />
                </div>
                <div className="userProfile__body nameField form-validation-arrange userinput">
                  <Label>Screenshot Time</Label>
                  {/* <div className="row">
                  <div className="col-md-4 domain-input-label text-center">
                    Hours
                  </div>
                  <br />
                  <div className=" col-md-4 domain-input-label text-center">
                    Minutes
                  </div>
                  <br />
                  <div className="col-md-4 domain-input-label text-center ">
                    Seconds
                  </div>
                  </div> */}
                  <div className="globalInput--mod domain-input-group">
                    <InputGroup>
                      <div className="domain-time-block">
                        <InputGroupAddon
                          className="mr-2 hour"
                          addonType="prepend"
                        >
                          HH
                        </InputGroupAddon>
                        <div className="domain-input-block">
                          <Field
                            component={Input}
                            name="hour"
                            type="number"
                            placeholder="HH"
                            label="hour"
                            validate={checkHourValue}
                            min={0}
                            max={24}
                            inputClass="domain-edit-input modal-duration "
                            onChange={() => this.enableUpdateButton(false)}
                          />
                        </div>
                      </div>

                      <div className="domain-time-block">
                        <InputGroupAddon className="mr-2 " addonType="prepend">
                          MM
                        </InputGroupAddon>
                        <div className="domain-input-block">
                          <Field
                            component={Input}
                            name="minute"
                            type="number"
                            placeholder="MM"
                            validate={checkMinValue}
                            min={1}
                            max={59}
                            inputClass="domain-edit-input modal-duration "
                            onChange={() => this.enableUpdateButton(false)}
                          />
                        </div>
                      </div>

                      <div class="domain-time-block">
                        <InputGroupAddon className="mr-2 " addonType="prepend">
                          SS
                        </InputGroupAddon>
                        <div className="domain-input-block">
                          <Field
                            component={Input}
                            name="second"
                            type="number"
                            placeholder="SS"
                            validate={checkSecValue}
                            min={0}
                            max={59}
                            inputClass="domain-edit-input modal-duration"
                            onChange={() => this.enableUpdateButton(false)}
                          />
                        </div>
                      </div>
                    </InputGroup>
                  </div>
                </div>

                {this.props.roles.includes("SuperAdmin") &&
                  attributes.name !== "wicket" && (
                    <div className="userProfile__body nameField form-validation-arrange userinput">
                      <Label>Plan</Label>

                      <div className="subInput">
                        <div className="subscriptionContainer">
                          <Field
                            name="subscription"
                            component={Input}
                            type="radio"
                            value="basic"
                            id="basic"
                            labelClass="noExtraLabelField"
                            checked={this.props.subscription === "basic"}
                            onChange={() => this.enableUpdateButton(false)}
                          />{" "}
                          <Label
                            for="basic"
                            className={`${this.props.subscription === "basic" &&
                              "activePlan"}`}
                          >
                            Basic Plan
                          </Label>
                        </div>
                        <div className="subscriptionContainer">
                          <Field
                            name="subscription"
                            component={Input}
                            type="radio"
                            value="premium"
                            id="premium"
                            labelClass="noExtraLabelField"
                            checked={this.props.subscription === "premium"}
                            onChange={() => this.enableUpdateButton(false)}
                          />{" "}
                          <Label
                            for="premium"
                            className={`${this.props.subscription ===
                              "premium" && "activePlan"}`}
                          >
                            Premium Plan
                          </Label>
                        </div>
                      </div>
                    </div>
                  )}
                {this.props.roles.includes("SuperAdmin") && (
                  <div className="userProfile__body nameField form-validation-arrange userinput toggle-version">
                    <Label>Restrict Campaign</Label>
                    <Label className="mb-0 ml-1 mt-0 switch">
                      <Field
                        name="campaignRestrictionFlag"
                        id="campaignRestrictionFlag"
                        component="input"
                        type="checkbox"
                        checked={this.props.campaignRestrictionFlag}
                        onChange={() => this.enableUpdateButton(false)}
                      />
                      <span className="slider round" />
                    </Label>
                    <div className="globalInput--mod domain-input-group">
                      <InputGroup
                        style={{
                          background:
                            !this.props.campaignRestrictionFlag && "#e3e3ea"
                        }}
                      >
                        <div className="domain-time-block">
                          <InputGroupAddon
                            className="mr-2 hour"
                            addonType="prepend"
                          >
                            HH
                          </InputGroupAddon>
                          <div className="domain-input-block">
                            <Field
                              component={Input}
                              name="campaignRestrictHour"
                              type="number"
                              placeholder="HH"
                              label="hour"
                              validate={checkHourValue}
                              min={0}
                              max={24}
                              inputClass="domain-edit-input modal-duration "
                              onChange={() => this.enableUpdateButton(false)}
                              disabled={!this.props.campaignRestrictionFlag}
                            />
                          </div>
                        </div>
                        <div className="domain-time-block">
                          <InputGroupAddon
                            className="mr-2 "
                            addonType="prepend"
                          >
                            MM
                          </InputGroupAddon>
                          <div className="domain-input-block">
                            <Field
                              component={Input}
                              name="campaignRestrictMinute"
                              type="number"
                              placeholder="MM"
                              validate={checkRestrictionMinValue}
                              min={1}
                              max={59}
                              inputClass="domain-edit-input modal-duration "
                              onChange={() => this.enableUpdateButton(false)}
                              disabled={!this.props.campaignRestrictionFlag}
                            />
                          </div>
                        </div>
                        <div className="domain-time-block">
                          <InputGroupAddon
                            className="mr-2 "
                            addonType="prepend"
                          >
                            SS
                          </InputGroupAddon>
                          <div className="domain-input-block">
                            <Field
                              component={Input}
                              name="campaignRestrictSecond"
                              type="number"
                              placeholder="SS"
                              validate={[
                                checkSecValue,
                                validateRestrictionCampaignDuration
                              ]}
                              min={0}
                              max={59}
                              inputClass="domain-edit-input modal-duration"
                              onChange={() => this.enableUpdateButton(false)}
                              disabled={!this.props.campaignRestrictionFlag}
                            />
                          </div>
                        </div>
                      </InputGroup>
                    </div>
                  </div>
                )}
                <div className="userProfile__body nameField form-validation-arrange userinput">
                  <Label className="mb-2">Central Map Location</Label>
                  <MapCenterPoint
                    location={this.props.currentCenterLocation}
                    enableUpdateButton={this.enableUpdateButton}
                    changeCenterLocationPoint={
                      this.props.changeCenterLocationPoint
                    }
                  />
                </div>
              </form>
              <div className="userProfile__changePassword mt-3">
                <div className="d-flex justify-content-end">
                  <button
                    className="primaryButton mt-0"
                    type="submit"
                    onClick={handleSubmit(values => {
                      this.props.editDomainDetails(values);
                      this.enableUpdateButton(true);
                    })}
                    disabled={this.state.disableUpdateButton}
                  >
                    Update
                  </button>
                </div>
              </div>
            </div>
          </div>{" "}
          {this.props.currentUserRoles.id === this.props.domains[0].id && (
            <div className="networkInformation clearfix">
              <div className="userProfile__info">
                <h4 className="userProfile__headerTitle">
                  {" "}
                  <i className="mr-3 bx bxs-pencil" />
                  Set Default Campaign
                </h4>
                <form className="validate-form">
                  <div className="form-validation-arrange userinput default-campaign">
                    <Label>Default Campaign</Label>
                    <div className="d-flex form-validation-arrange userinput">
                      {/* <FormGroup> */}
                      <Field
                        component={SelectAsync}
                        name="default_campaign"
                        currentDefaultCampaign={
                          this.props.domainDefaultCampaign &&
                          this.props.domainDefaultCampaign.value
                        }
                        isClearable
                        onChange={() =>
                          this.enableDefaultCampaignUpdateButton(false)
                        }
                      />
                      <button
                        className="primaryButton ml-3 mt-0 custom-primary-button"
                        type="submit"
                        onClick={handleSubmit(values => {
                          this.props.editDefaultCampaign(values);
                          this.enableDefaultCampaignUpdateButton(true);
                        })}
                        disabled={this.state.defaultCampaignUpdateButton}
                      >
                        Update
                      </button>
                    </div>
                  </div>
                </form>
              </div>
              <div>
                <Table
                  responsive
                  style={{ padding: "0 15px" }}
                  className="defaultCampaignTable"
                >
                  <thead>
                    <tr>
                      <th
                        className="pl-2"
                        style={{ width: "auto", padding: "0px" }}
                      >
                        Name
                      </th>
                      <th>Orientation</th>
                      <th style={{ width: "120px" }}>Status</th>
                      <th />
                    </tr>
                  </thead>
                  <tbody>
                    <tr
                      key={domainDefaultCampaign && domainDefaultCampaign.value}
                    >
                      <td className="word-break">
                        {domainDefaultCampaign
                          ? domainDefaultCampaign.label
                          : "N/A"}
                      </td>
                      <td>
                        {domainDefaultCampaign
                          ? domainDefaultCampaign.orientation
                          : "N/A"}
                      </td>
                      <td className="word-break">
                        <span
                          className={`content-text ${
                            domainDefaultCampaign.status === "live"
                              ? "content__status__online"
                              : domainDefaultCampaign.status
                              ? "content__status__offline"
                              : ""
                          }`}
                        />
                      </td>
                    </tr>
                  </tbody>
                </Table>
              </div>
            </div>
          )}
        </div>

        <div className="col-md-5">
          <div className="domainPlan">
            <h4 className="userProfile__headerTitle">Subscription Plan</h4>
            <div className="row">
              <div className="col-md-6">
                <span>Basic Plan</span>
                <ul>
                  <li>
                    {" "}
                    <div className="domainPlanIcon">
                      <i className="fas fa-check" />
                    </div>{" "}
                    Basic Feature Access
                  </li>

                  <li>
                    {" "}
                    <div className="domainPlanIcon">
                      <i className="fas fa-times" />
                    </div>{" "}
                    HLS Widget
                  </li>
                  <li>
                    <div className="domainPlanIcon">
                      <i className="fas fa-times" />
                    </div>{" "}
                    Youtube Widget
                  </li>
                  <li>
                    <div className="domainPlanIcon">
                      <i className="fas fa-times" />
                    </div>{" "}
                    Pic To Screen Widget
                  </li>
                </ul>
              </div>
              <div className="col-md-6">
                <span>Premium Plan</span>
                <ul>
                  <li>
                    <div className="domainPlanIcon">
                      <i className="fas fa-check" />
                    </div>{" "}
                    Basic Feature Access
                  </li>

                  <li>
                    {" "}
                    <div className="domainPlanIcon">
                      <i className="fas fa-check" />
                    </div>{" "}
                    HLS Widget
                  </li>
                  <li>
                    {" "}
                    <div className="domainPlanIcon">
                      <i className="fas fa-check" />
                    </div>{" "}
                    Youtube Widget
                  </li>
                  <li>
                    {" "}
                    <div className="domainPlanIcon">
                      <i className="fas fa-check" />
                    </div>{" "}
                    Pic To Screen Widget
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default connect(state => {
  const selector = formValueSelector("DomainEditForm");
  return {
    subscription: selector(state, "subscription"),
    campaignRestrictionFlag: selector(state, "campaignRestrictionFlag")
  };
})(
  reduxForm({
    form: "DomainEditForm"
  })(DomainDetail)
);
